const baseDotStyles = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
};

export const onlineDotStyles = {
  ...baseDotStyles,
  backgroundColor: 'success.main',
};

export const offlineDotStyles = {
  ...baseDotStyles,
  backgroundColor: 'text.disabled',
};
